import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import stylisRTLPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { theme } from './theme/theme';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import { BrowserRouter } from "react-router-dom";
import Router from "./Router";
import { useTranslation } from 'react-i18next';
import { RTL_LANGUAGES } from './i18n';
//import CountdownPage from './pages/CountdownPage';

const rtlCache = createCache({ key: 'muirtl', stylisPlugins: [prefixer, stylisRTLPlugin] });
const ltrCache = createCache({ key: 'muiltr' });

function App() {
  const { i18n } = useTranslation();
  const [isRTL, setIsRTL] = useState(RTL_LANGUAGES.includes(i18n.language));

  useEffect(() => {
    const handleLangChange = (lng) => {
      const rtl = RTL_LANGUAGES.includes(lng);
      setIsRTL(rtl);
      document.documentElement.dir = rtl ? 'rtl' : 'ltr';
      document.documentElement.lang = lng;
    };
    i18n.on('languageChanged', handleLangChange);
    handleLangChange(i18n.language);
    return () => i18n.off('languageChanged', handleLangChange);
  }, [i18n]);

  const activeTheme = createTheme(theme, { direction: isRTL ? 'rtl' : 'ltr' });

  const childProps = {
    isAuthenticated: true,
    userRole: "admin"
  };
  /*return (
    <CountdownPage />
  );*/
  return (
    <CacheProvider value={isRTL ? rtlCache : ltrCache}>
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <BrowserRouter>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 0,
            mt: 8,
            color: '#fff',
          }}
        >
            <Router childProps={childProps} />
        </Box>
        <Footer />
      </Box>
      </BrowserRouter>
    </ThemeProvider>
    </CacheProvider>
  );
}

export default App;